import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/firestore";

const app = firebase.initializeApp({
  apiKey: 'AIzaSyCGfo2skFRo0jVGiVWTQcxDexvuOMYtiwU',
  authDomain: "refu-wrold-com.firebaseapp.com",
  projectId: "refu-wrold-com",
  storageBucket: "refu-wrold-com.appspot.com",
  messagingSenderId: "489364037559",
  appId: "1:489364037559:web:a36d286a8d918ec5929232",
  measurementId: "G-4JBG0C4FE5"
});

const db = app.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
export { db, auth, storage };
// current project is world com app:
